import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { acceptEventSubmission, deleteEvent, getCityList, getEventCategoryList, getEventDetails, getEventsList, getEventSubmissionDetails, getEventSubmissionList, rejectEventSubmission, updateEvent } from "../api/events";
import { createEvent } from "../api/events";

export const useGetEventCategories = () => {
    return useQuery({
        queryKey: ['eventCategories'],
        queryFn: getEventCategoryList,
    });
}

export const useGetCityList = () => {
    return useQuery({
        queryKey: ['cities'],
        queryFn: () => getCityList(),
    });
}

export const useCreateEvent = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createEvent'],
        mutationFn: ({ data, coverImage }) => createEvent(data, coverImage),
        onSuccess: () => {
            queryClient.invalidateQueries(['events']);
        },
    });
}

export const useGetEventList = () => {
    return useQuery({
        queryKey: ['events'],
        queryFn: () => getEventsList(),
    });
}

export const useDeleteEvent = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteEvent'],
        mutationFn: (id) => deleteEvent(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['events']);
        },
    });
}

export const useGetEventDetailsById = (id) => {
    return useQuery({
        queryKey: ['eventDetails', id],
        queryFn: () => getEventDetails(id),
        enabled: !!id,
    });
}

export const useUpdateEvent = (id) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateEvent'],
        mutationFn: ({ data, coverImage }) => updateEvent(id, data, coverImage),
        onSuccess: () => {
            queryClient.invalidateQueries(['events']);
        },
    });
}

export const useGetEventSubmissionList = () => {
    return useQuery({
        queryKey: ['eventSubmissions'],
        queryFn: () => getEventSubmissionList(),
    });
}

export const useGetEventSubmissionDetailsById = (id) => {
    return useQuery({
        queryKey: ['eventSubmissionDetails', id],
        queryFn: () => getEventSubmissionDetails(id),
        enabled: !!id,
    });
}

export const useAcceptEventSubmission = (id) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['user-enrolled-events'],
        mutationFn: (data) => acceptEventSubmission(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['eventSubmissionDetails', id]);
        },
    });
}

export const useRejectEventSubmission = (id) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['user-enrolled-events'],
        mutationFn: (data) => rejectEventSubmission(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['eventSubmissionDetails', id]);
        },
    });
}